import React, { createContext, useContext, useState, useEffect } from 'react';

const ImboxContext = createContext();

export const ImboxProvider = ({ children }) => {
  const [showImboxModal, setShowImboxModal] = useState(false);
  const [addToBagEvent, setAddToBagEvent] = useState(null);

  useEffect(() => {
    const handleAddToBag = (event) => {
      setAddToBagEvent(event);
    };
    const addToBagButtons = document.querySelectorAll('#add-to-bag');
    addToBagButtons.forEach((btn) => {
      btn.addEventListener('click', handleAddToBag);
    });
    return () => {
      addToBagButtons.forEach((btn) => {
        btn.removeEventListener('click', handleAddToBag);
      });
    };
  }, []);

  return (
    <ImboxContext.Provider value={{ showImboxModal, setShowImboxModal, addToBagEvent }}>
      {children}
    </ImboxContext.Provider>
  );
};

export const useImbox = () => {
  return useContext(ImboxContext);
};

export const withImbox = (Component) => {
  return function WrappedComponent(props) {
    const imboxContext = useImbox();
    return <Component {...props} {...imboxContext} />;
  };
};
